const AI_SERVICE_URL = process.env.REACT_APP_AI_SERVICE_URL || 'http://localhost:3001';

export async function sendChatMessage({ message, tone, conversationHistory, context, onEvent, onEnd, onError }) {
  try {
    const response = await fetch(`${AI_SERVICE_URL}/api/chat`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message, tone, conversationHistory, context })
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() || '';

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        if (line.startsWith('event: ')) {
          const eventType = line.slice(7);
          const dataLine = lines[i + 1];
          if (dataLine?.startsWith('data: ')) {
            try {
              const data = JSON.parse(dataLine.slice(6));
              if (eventType === 'done') {
                onEnd?.();
              } else if (eventType === 'error') {
                onError?.(new Error(data.error));
              } else {
                onEvent?.(eventType, data);
              }
            } catch (e) {
              // JSON parse error, ignore
            }
          }
        }
      }
    }

    onEnd?.();
  } catch (error) {
    onError?.(error);
  }
}
